import { defineAsyncComponent } from 'vue'
export default {
  authentication: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/authentication.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m))
}